import { useEffect, useState } from "react";
import api from "../api";
import "./software.css";

export default function SoftwareArchived() {
  const [archived, setArchived] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    loadArchived();
  }, []);

  const loadArchived = async () => {
    const res = await api.get("/software");
    const all = res.data || [];

    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

    const archivedLicenses = [];

    all.forEach((l) => {
      l.renewalHistory?.forEach((r) => {
        if (new Date(r.renewedAt) >= sixMonthsAgo) {
          archivedLicenses.push({
            ...l,
            archivedFrom: r.startDate,
            archivedTo: r.endDate,
            archivedPrice: r.price,
            archivedInvoice: r.invoiceNo,
            renewedAt: r.renewedAt,
          });
        }
      });
    });

    setArchived(archivedLicenses);
  };

  /* 🔍 SEARCH FILTER */
  const filteredArchived = archived.filter((l) =>
    l.softwareName?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="software-page">
      {/* HEADER */}
      <div className="software-header">
        <h2>Archived Licenses (Last 6 Months)</h2>

        <input
          type="text"
          placeholder="Search software..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            height: 44,
            padding: "0 14px",
            borderRadius: 12,
            border: "1.5px solid #d1d5db",
            background: "#f9fafb",
            fontSize: 14,
            fontWeight: 500,
            minWidth: 240,
          }}
        />
      </div>

      {/* NO DATA */}
      {filteredArchived.length === 0 ? (
        <div style={{ marginTop: 40, textAlign: "center", fontWeight: 600 }}>
          No archived licenses found
        </div>
      ) : (
        <div className="license-blocks">
          {filteredArchived.map((l, i) => (
            <div className="license-card" key={i}>
              <div className="license-card-top">
                <span className="license-title">
                  {l.softwareName} – Archived
                </span>
              </div>

              <div className="lc-row">
                <span>Software Type</span>
                <strong>{l.softwareType}</strong>
              </div>

              <div className="lc-row">
                <span>Version</span>
                <strong>{l.version}</strong>
              </div>

              <div className="lc-row">
                <span>License Key</span>
                <strong>{l.licenseKey}</strong>
              </div>

              <div className="lc-row">
                <span>Seats</span>
                <strong>{l.seats}</strong>
              </div>

              <div className="lc-row">
                <span>Login ID</span>
                <strong>{l.loginId}</strong>
              </div>

              <div className="lc-row">
                <span>Password</span>
                <strong>{l.password}</strong>
              </div>

              <div className="lc-row">
                <span>User</span>
                <strong>{l.assignedUser?.name || "Stock"}</strong>
              </div>

              <div className="lc-row">
                <span>PC Name</span>
                <strong>{l.pcName}</strong>
              </div>

              <div className="lc-row">
                <span>IP Address</span>
                <strong>{l.ipAddress}</strong>
              </div>

              <div className="lc-row">
                <span>Location</span>
                <strong>{l.location}</strong>
              </div>

              <div className="lc-row">
                <span>Validity</span>
                <strong>{l.validity}</strong>
              </div>

              <div className="lc-row">
                <span>Original Purchase Date</span>
                <strong>{l.purchaseDate?.slice(0, 10)}</strong>
              </div>

              <div className="lc-row">
                <span>Archived Period</span>
                <strong>
                  {l.archivedFrom?.slice(0, 10)} → {l.archivedTo?.slice(0, 10)}
                </strong>
              </div>

              <div className="lc-row">
                <span>Renewed On</span>
                <strong>{l.renewedAt?.slice(0, 10)}</strong>
              </div>

              <div className="lc-row">
                <span>Invoice No</span>
                <strong>{l.archivedInvoice}</strong>
              </div>

              <div className="lc-row">
                <span>Vendor</span>
                <strong>{l.vendor}</strong>
              </div>

              <div className="lc-row">
                <span>Vendor Contact</span>
                <strong>{l.vendorContactNo || "-"}</strong>
              </div>

              <div className="lc-row">
                <span>Vendor Email</span>
                <strong>{l.vendorEmail || "-"}</strong>
              </div>

              <div className="lc-row">
                <span>Description</span>
                <strong>{l.description}</strong>
              </div>

              <div className="lc-price">₹ {l.archivedPrice}</div>

              <div
                style={{
                  marginTop: 10,
                  padding: "8px 10px",
                  borderRadius: 10,
                  background: "#f1f5f9",
                  fontSize: 12,
                  fontWeight: 700,
                  textAlign: "center",
                }}
              >
                📦 Archived License (Auto removed after 6 months)
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
